import axiosInstance from './axios.service';

export const integrateMenu = async (data, headers = {}) => {
  const url = '/operator/v1/menu/integrate';

  try {
    const response = await axiosInstance.post(url, data, { headers });
    return response;
  } catch (error) {
    console.error('Error in integrateMenu:', error);
    throw error;
  }
};

export const getMenuIntegrationsList = async (data = {}, headers = {}) => {
  const url = '/operator/v1/menu/integrations-list';

  try {
    const response = await axiosInstance.post(url, data, { headers });
    return response;
  } catch (error) {
    console.error('Error in getMenuIntegrationsList:', error);
    throw error;
  }
};
